import styled from 'styled-components';
import { margin } from 'styled-system';
import { flexItem } from '../helpers/flexItem';
import { getOmittableProps } from '../helpers/omit';
var styleProps = getOmittableProps(margin, flexItem);
export var FieldWrapper = /*#__PURE__*/styled.div.withConfig({
  shouldForwardProp: function shouldForwardProp(p) {
    return !styleProps.has(p);
  }
}).withConfig({
  displayName: "FieldWrapper"
})(["min-width:1px;:not(:first-child){margin-top:", "px;}&&{", " ", "}"], function (p) {
  var _p$$gap;

  return p.theme.space[(_p$$gap = p.$gap) !== null && _p$$gap !== void 0 ? _p$$gap : 4];
}, margin, flexItem);
export default FieldWrapper;